import { useState, useCallback } from 'react';
import axios from 'axios';
import { KpiData } from '../types';
import { API_BASE } from '../constants';

export interface JournalKpiState {
  kpi: KpiData | null;
  kpiLoading: boolean;
  fetchKpi: () => Promise<void>;
}

/**
 * Загружает агрегированные KPI-показатели журнала:
 * общую сумму, количество позиций, количество задействованных аптек.
 */
export function useJournalKpi(filterParams: Record<string, string>): JournalKpiState {
  const [kpi, setKpi] = useState<KpiData | null>(null);
  const [kpiLoading, setKpiLoading] = useState(true);

  const fetchKpi = useCallback(async () => {
    setKpiLoading(true);
    try {
      const resp = await axios.get(`${API_BASE}/journal/analytics/summary`, {
        params: filterParams,
      });
      if (resp.data?.success) setKpi(resp.data.data);
    } catch (e) {
      console.error('KPI fetch error:', e);
    } finally {
      setKpiLoading(false);
    }
  }, [filterParams]);

  return { kpi, kpiLoading, fetchKpi };
}
